import HelpBox from "./HelpBox";

export default function ClimateRelatedRisksHelp() {
    return (
        <HelpBox>
            <HelpBox.Header>Climate Related Risks Help</HelpBox.Header>
            <HelpBox.Content>
                <p>
                    Climate-related Risks are risks identified through the Climate-related Scenario Analysis process, that have the potential to make a substantive financial or strategic impact on your business.
                </p>
                <p>
                    Create risks using the table.
                </p>
                <p>
                    ClimateTracker then allows you to group these Risks in different ways for different disclosures. For example, you may add Risks over time in response to climate-related events or as your scenario modeling becomes more sophisticated.
                    To group the Risks you require for this disclosure, in the left hand side, enter a name for the set of Risks that are relevant to this disclosure, then select from existing Risks in the table that you have created, or create and select new elements.
                    This ensures that only the relevant Risks data will be used in the disclosure you are currently building.
                </p>
                <p>
                    You are also required to answer the question on the left hand side, to describe how the risks you have selected for this disclosure provide input into capital deployment and funding processes.
                </p>
            </HelpBox.Content>
        </HelpBox>
    );
}
